import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { AuthService } from '@auth0/auth0-angular';
import { filter, switchMap } from 'rxjs';

import { jsonDefaultRequestOptions } from 'src/app/shared/constants/http.constants';
import { handleHttpResponse } from 'src/app/shared/functions/http.functions';
import { baseEventsUrl } from 'src/app/shared/services/events/events.service';
import { GetHostFeedbackRequest } from 'src/app/shared/services/events/feedback/event-feedback.models';
import {
  BaseFeedbackSlot,
  FeedbackSlot,
  HostFeedback
} from 'src/app/shared/services/public-events/feedback/public-events-feedback.models';
import { AuthenticationStore } from 'src/app/shared/state/authentication/authentication.state';

const getFeedbackSlotsUrl = (eventId: string, userId: string) =>
  `${baseEventsUrl}/${eventId}/feedback/slots/${userId}`;
const submitFeedbackUrl = (eventId: string, userId: string) =>
  `${baseEventsUrl}/${eventId}/feedback/${userId}`;
const getHostFeedbackUrl = (eventId: string) =>
  `${baseEventsUrl}/${eventId}/feedback/details`;

@Injectable({
  providedIn: 'root'
})
export class EventFeedbackService {
  private _auth0Service = inject(AuthService);
  private _httpClient = inject(HttpClient);
  private _authStore = inject(AuthenticationStore);

  getFeedbackSlots$(eventId: string, userId: string) {
    return this._auth0Service.isAuthenticated$.pipe(
      filter((authenticated) => authenticated),
      switchMap(() =>
        handleHttpResponse(
          this._httpClient.get<FeedbackSlot[]>(
            getFeedbackSlotsUrl(eventId, userId),
            jsonDefaultRequestOptions
          ),
          'getFeedbackSlots$',
          this._authStore.logout
        )
      )
    );
  }

  submitFeedback$(eventId: string, userId: string, payload: BaseFeedbackSlot) {
    return this._auth0Service.isAuthenticated$.pipe(
      filter((authenticated) => authenticated),
      switchMap(() =>
        handleHttpResponse(
          this._httpClient.put<BaseFeedbackSlot>(
            submitFeedbackUrl(eventId, userId),
            payload,
            jsonDefaultRequestOptions
          ),
          'getFeedbackSlots$',
          this._authStore.logout
        )
      )
    );
  }

  getHostFeedback$(eventId: string, payload: GetHostFeedbackRequest) {
    return this._auth0Service.isAuthenticated$.pipe(
      filter((authenticated) => authenticated),
      switchMap(() =>
        handleHttpResponse(
          this._httpClient.post<HostFeedback[]>(
            getHostFeedbackUrl(eventId),
            payload,
            jsonDefaultRequestOptions
          ),
          'getHostFeedback$',
          this._authStore.logout
        )
      )
    );
  }
}
